import React from 'react'
import mount from '../lib/mount'
import NewJobSubscription from '../components/NewJobSubscription'

// NewJobSubscription component doesn't require redux.
document.addEventListener('turbolinks:load', () => {
  const el = document.getElementById('react-new-job-subscription')
  if (el) {
    const data = JSON.parse(el.getAttribute('data'))
    mount(
      el,
      <NewJobSubscription
        stripePublishable={data.stripePublishable}
        cost={data.cost}
        />,
    )
  }
})
